"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inactiveStatus = exports.classes = void 0;
var classes = {
  container: 'members-header-class',
  headerClass: 'header-class',
  marginTop32: 'margin-top-32',
  marginTop8: 'margin-top-8',
  marginTop10: 'margin-top-10',
  approvalLoaderContainer: 'approval-loader-container',
  viewMembersPillContainer: 'view-member-pills-container',
  tagsContainer: 'members-tag-container'
};
exports.classes = classes;
var inactiveStatus = 'inactive';
exports.inactiveStatus = inactiveStatus;